const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!-/:-@[-`{-~])\S{8,}$/;

export function isPasswordValid(password: string): boolean {
  return PASSWORD_REGEX.test(password);
}
